<script lang="ts">
  import { link } from "svelte-spa-router";
  import { buttonVariants } from "$ui/button";

  export let title: string = "";
  export let href: string = "";

  let internalLink = !href.startsWith("https://");
</script>

<a class="h-full card flex flex-col overflow-hidden" {href} target="_blank" rel="noreferrer noopener">
  <div class="flex-1 p-5 flex flex-col">
    <div class="[&>svg]:w-7">
      <slot name="icon" />
    </div>
    <h3 class="mt-5 text-lg font-semibold line-clamp-2">{title}</h3>
    <p class="mt-4 mb-6 line-clamp-3"><slot name="description" /></p>
    <div class="flex-1 flex items-end">
      {#if internalLink}
        <a {href} class={buttonVariants({ variant: "link" })} use:link>
          <slot name="link" />
        </a>
      {:else}
        <a {href} class={buttonVariants({ variant: "link" })}>
          <slot name="link" />
        </a>
      {/if}
    </div>
  </div>
</a>
